
import { defineComponent } from 'vue'

export default defineComponent({
    name: "GifSpinner",
    props: {
        iconUrl: {
            type: String,
        }
    }, setup() {

    },
})
